/* @flow */

import { XhrResponseType } from '../../../../helpers/jsHelpers/xhr';
import { commonPromisedXMLHttpRequest } from '../../helpers/CommonPromisedXMLHttpRequest';
import { createCustomNetworkError } from '../../helpers/CreateCustomNetworkError';
import { CustomNetworkError } from '../../helpers/CustomNetworkError';
import { HttpStatus } from '../../v8/constants/NetworkCodesAndMessages';
import { HttpMethod } from '../../v8/types/HttpMethod';

const errorCallBack = (): CustomNetworkError => createCustomNetworkError(HttpStatus.Error);

const dmsLogoutRequest: (logoutUrl?: string) => Promise<void> = (logoutUrl) => {
  if (!logoutUrl) {
    // No logout URL: nothing to do
    return Promise.resolve();
  }

  // We don't care about the response
  return commonPromisedXMLHttpRequest(logoutUrl, HttpMethod.GET, XhrResponseType.Json, null, null, null, true, errorCallBack).promise.catch(() => Promise.resolve());
};

export default dmsLogoutRequest;
